enum ResidentRoleEnum {
    Tenant = 1,
    Stakeholder = 2
}

export default ResidentRoleEnum;
